
import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  ref,
} from 'vue';
import BackgroundPattern from '@/components/BackgroundPattern.vue';

export default defineComponent({
  components: {
    BackgroundPattern,
  },
  props: {
    spacer: {
      type: String,
      required: false,
      default: () => 'none',
    },
    spacerCloudsPlacement: {
      type: String,
      required: false,
      default: () => 'bottom',
    },
    spacerBarAlign: {
      type: String,
      required: false,
      default: () => 'right',
    },
  },

  setup() {
    const pattern = ref<InstanceType<typeof HTMLElement>>();
    const container = ref<InstanceType<typeof HTMLElement>>();
    const map = ref<InstanceType<typeof HTMLElement>>();

    const {
      ioappConfig: {
        themeUri,
      },
    } = window;

    const handleMapSize = () => {
      if (map.value) {
        map.value.style.height = `${map.value.offsetWidth * 0.5100049}px`;
      }
    };

    onMounted(() => {
      if (pattern.value) {
        pattern.value.style.backgroundImage = `url('${themeUri}/assets/img/hero-pattern.svg')`;
      }
      if (container.value && map.value) {
        map.value.style.backgroundImage = `url('${themeUri}/assets/img/Castrop-Rauxel_Karte_v1.png')`;
      }

      window.addEventListener('resize', handleMapSize);
      handleMapSize();
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleMapSize);
    });

    return {
      pattern,
      container,
      map,
    };
  },
});
